<template lang="pug">
transition
  div(v-if="show" :style="`background: ${overlayColor};`").wrap-now-loading.f.fh
    div
      div.f.fc
        v-progress-circular(:color="pallete.$active_color" indeterminate)
      span(v-if="message"
        :style="`color: ${pallete.$active_color};`").message.block.fz14.text-center.mt10 {{message}}
</template>

<style lang="scss" scoped>
.wrap-now-loading {
  position: fixed;
  z-index: 1000;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}
/* アニメーション中のスタイル */
.v-leave-active, .v-enter-active {
  transition: opacity 0.4s;
}

/* 表示アニメーション */
.v-enter, .v-leave-to {
  opacity: 0;
}
.v-enter-to, .v-leave {
  opacity: 1;
}
</style>

<script>

export default {
  props: {
    show: {
      type: Boolean,
      required: true
    },
    overlayColor: {
      type: String,
      default: '#fff'
    },
    message: {
      type: String,
      default: ''
    }
  }
}
</script>
